import * as React from 'react';
import { Box, Button, Card, Grid, Icon, Typography, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { applicationInfo, environment } from '../../../shared/environment';
import { LayoutDashboard } from '../../../shared/layouts';

interface IShortcut {
    title: string;
    description: string;
    icon: string;
    path: string;
}

export const Dashboard: React.FC = () => {
    const theme = useTheme();
    const navigate = useNavigate();
    const env = environment();
    const logo = theme.palette.mode === 'dark' ? env.logoLight : env.logo;

    const shortcuts: IShortcut[] = [
        {
            title: 'Vagas',
            description: 'Acompanhe requisicoes, candidatos e andamento das oportunidades.',
            icon: 'person_add_alt_1_outlined',
            path: '/talentsphere/vacancy',
        },
        {
            title: 'Banco de Talentos',
            description: 'Consulte curriculos e perfis disponiveis para novas posicoes.',
            icon: 'groups_outlined',
            path: '/talentsphere/resume',
        },
        {
            title: 'Empresas',
            description: 'Gerencie empresas, pessoas e estruturas corporativas.',
            icon: 'business_outlined',
            path: '/corpsphere/company',
        },
        {
            title: 'Usuarios',
            description: 'Revise acessos, usuarios e grupos da aplicacao.',
            icon: 'admin_panel_settings_outlined',
            path: '/authsphere/user',
        },
    ];

    return (
        <LayoutDashboard title=''>
            <Box display='flex' flexDirection='column' gap={2}>
                <Card
                    sx={{
                        p: 3,
                        borderRadius: 1,
                        border: '1px solid',
                        borderColor: 'divider',
                        boxShadow: 'none',
                        overflow: 'hidden',
                    }}
                >
                    <Grid container spacing={2} alignItems='center'>
                        <Grid item xs={12} md={7}>
                            <Box display='flex' flexDirection='column' gap={1}>
                                <Typography variant='overline' color='secondary.main' fontWeight={800}>
                                    {applicationInfo.organizationName}
                                </Typography>
                                <Typography variant='h4' color='text.primary' fontWeight={800}>
                                    {applicationInfo.applicatioName}
                                </Typography>
                                <Typography color='text.secondary' maxWidth={620}>
                                    Portal operacional para gestao de vagas, banco de talentos, empresas e acessos.
                                </Typography>
                            </Box>
                        </Grid>
                        <Grid item xs={12} md={5}>
                            <Box
                                display='flex'
                                justifyContent={{ xs: 'flex-start', md: 'flex-end' }}
                                alignItems='center'
                                sx={{ opacity: theme.palette.mode === 'dark' ? 0.92 : 1 }}
                            >
                                <Box
                                    component='img'
                                    src={logo}
                                    alt='MTP'
                                    sx={{
                                        width: { xs: 180, md: 260 },
                                        maxWidth: '100%',
                                        height: 'auto',
                                        objectFit: 'contain',
                                    }}
                                />
                            </Box>
                        </Grid>
                    </Grid>
                </Card>

                <Grid container spacing={1}>
                    {shortcuts.map((shortcut) => (
                        <Grid item xs={12} sm={6} lg={3} key={shortcut.path}>
                            <Card
                                sx={{
                                    height: '100%',
                                    p: 2,
                                    borderRadius: 1,
                                    border: '1px solid',
                                    borderColor: 'divider',
                                    boxShadow: 'none',
                                    transition: 'all .2s',
                                    ':hover': {
                                        borderColor: 'secondary.main',
                                        boxShadow: '0 8px 20px rgba(16, 24, 40, 0.08)',
                                    },
                                }}
                            >
                                <Box display='flex' flexDirection='column' gap={1.5} height='100%'>
                                    <Box display='flex' alignItems='center' gap={1}>
                                        <Icon color='secondary'>{shortcut.icon}</Icon>
                                        <Typography color='text.primary' fontWeight={800}>
                                            {shortcut.title}
                                        </Typography>
                                    </Box>
                                    <Typography color='text.secondary' variant='body2' flex={1}>
                                        {shortcut.description}
                                    </Typography>
                                    <Button
                                        size='small'
                                        variant='outlined'
                                        color='primary'
                                        endIcon={<Icon>arrow_forward</Icon>}
                                        onClick={() => navigate(shortcut.path)}
                                        sx={{ alignSelf: 'flex-start', fontWeight: 700 }}
                                    >
                                        Abrir
                                    </Button>
                                </Box>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Box>
        </LayoutDashboard>
    );
};
